export default function PizzaShopIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="32" r="28" fill="#e0a050" />
      <circle cx="32" cy="32" r="23" fill="#d23a22" />
      <circle cx="32" cy="32" r="21" fill="#ffd77a" />
      <path d="M32 32 L32 11 A21 21 0 0 1 50 22 Z" fill="#ffe7a8" stroke="#a8673a" strokeWidth="1.5" />
      <path d="M32 11v42M11 32h42M17 17l30 30M47 17L17 47" stroke="#a8673a" strokeWidth="1.5" opacity="0.6" />
      <circle cx="24" cy="24" r="4.5" fill="#c0281c" />
      <circle cx="40" cy="40" r="4.5" fill="#c0281c" />
      <circle cx="22" cy="40" r="4.5" fill="#c0281c" />
      <circle cx="41" cy="24" r="4.5" fill="#c0281c" />
      <circle cx="32" cy="33" r="2.6" fill="none" stroke="#222" strokeWidth="2" />
      <path d="M44 32c2-3 5-3 6 0" stroke="#2f9e3a" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}
